import { addNewRelicPageAction } from 'ddc-new-relic';
import { 
	DDC_DEALER_DR_LEASE_ENABLED,
	WALLET_UPDATE_STATE,
	WALLET_CONFIG_KEY,
	WALLET_DEFAULT_OBJ,
	SECTIONS_VDP_PAGE_ID_PARTIAL,
} from '../global-constants.js';
import { ddcLog } from '../utils/logger.js';

// TODO Make a way in the API to append CSS (or other things) to the head?
// Or load this as an external file? (Not great for performance, though.)
export const appendToHead = (markup) => {
	document.querySelector('head').appendChild(markup);
}

export const capitalizeFirstLetter = string => {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

// 'User Geographic Routing' 😆
export const getRegion = (userRegion = '') => {
	const westStates = ['AZ', 'CA', 'CO', 'ID', 'KS', 'MT', 'ND', 'NE', 'NM', 'NV', 'OR', 'SD', 'UT', 'WA', 'WY'];
	return westStates.includes(userRegion) ? 'us-west-2' : 'us-east-1';
}

export const getPrivateAPIContent = (category, field, defaultValue) => {
	return window?.DDC?.PrivateAPI?.content[category]?.[field] || defaultValue;
}

const getWalletConfigLs = () => JSON.parse(localStorage.getItem(WALLET_CONFIG_KEY)) || WALLET_DEFAULT_OBJ;

const getWalletDataIsDefault = walletData => JSON.stringify(walletData) === JSON.stringify(WALLET_DEFAULT_OBJ);

const tryWalletConfig = () => {
	return new Promise(resolve => {
		let walletDataReceived = false;

		const getPaymentsInfoCompletedHandler = (walletData) => {
			walletDataReceived = true;
			resolve(walletData);
		};
		// subscribe to completed event to get wallet data
		window.caiEventBus.on('wallet:getPaymentsInformation:completed', getPaymentsInfoCompletedHandler);

		// emit get payment info request to get wallet data
		window.caiEventBus.emit('wallet:getPaymentsInformation:request');

		setTimeout(() => {
			// unlisten/unregister get payment info completed event to avoid duplicates handler with wallet interactions/filter changes
			window.caiEventBus.off('wallet:getPaymentsInformation:completed', getPaymentsInfoCompletedHandler);
			if (!walletDataReceived) {
				addNewRelicPageAction('ddc-mywallet-integration wallet data not resolved in time');
				resolve(null);
			}
		}, 500);
	});
}

export const getWalletConfig = () => {
	// eslint-disable-next-line
	return new Promise(async resolve => {
		let walletData = await tryWalletConfig();
		
		// If we don't get walletData or it's just the default object with null/empty values
		// try to get wallet from local storage
		if (getWalletDataIsDefault(walletData) || walletData === null) {
			walletData = getWalletConfigLs();
			addNewRelicPageAction('ddc-mywallet-integration wallet data is default or null', {
				walletData
			});
		}
		resolve(walletData);
	});
}

export const getWalletData = async (field1, field2) => {
	const config = await getWalletConfig();

	if (!field1) {
		return null;
	}

	if (field2) {
		return config[field1][field2];
	}

	return config[field1];
}

export const stringToElements = (inputHtml) => {
	const result = document.createElement('template');
	const html = inputHtml.trim();
	result.innerHTML = html;
	return result.content.firstChild;
}

// In priority, get MMD ID from:
// - vehicle's dealer codes if it exists
// - website's dealer codes
// - Private API <-- comes from TPS integration 
//   (^ will remove once mmd is in DNA for all AMD integrations)

const getMmdIdByKey = (vehicle, dealerData, key) => {
    return parseInt(vehicle?.dealerCodes?.[key], 10) ||
        parseInt(dealerData?.dealershipCodes?.[key], 10) ||
        parseInt(getPrivateAPIContent('digital-retailing', 'dealerId', 2090), 10);
}

export const getMmdId = (vehicle, dealerData) => {
    return getMmdIdByKey(vehicle, dealerData, 'mmd');
}

export const getMmdIdBOA = (vehicle, dealerData) => {
    return getMmdIdByKey(vehicle, dealerData, 'mmd_boa');
}

export const setWalletUpdateState = source => {
	localStorage.setItem(WALLET_UPDATE_STATE, JSON.stringify({ lastUpdateSource: source }));
}

export const getWalletUpdateState = () => JSON.parse(localStorage.getItem(WALLET_UPDATE_STATE));

export const setDealerDRLeaseEnabled = (flag) => {
	localStorage.setItem(DDC_DEALER_DR_LEASE_ENABLED, flag);
}

export const getDealerDRLeaseEnabled = () => localStorage.getItem(DDC_DEALER_DR_LEASE_ENABLED);

export const getWalletScriptHost = (subdomain) => {
	if (window.location.search.includes('_useUdsDevEnv')) {
		const prNum = window.location.search.match(/_useUdsDevEnv=(\d+)/)[1];
		ddcLog('Using UDS dev env', { prNum });
		return `https://unified-wallet.s3.amazonaws.com/pr-${prNum}`;
	}
	
	return `https://${subdomain}.kbb.com/my-wallet`;
}

export const isSectionsVDP = () => window?.DDC?.dataLayer?.page?.pageInfo?.pageId?.includes(SECTIONS_VDP_PAGE_ID_PARTIAL);
